import * as types from 'model/actionTypes'
import { SettingsT } from 'shared/types/model'

export function receiveSettings (settings: SettingsT) {
  return {
    type: types.RECEIVE_SETTINGS,
    settings
  }
}
